<template>
  <div>
    <v-card width="100%" v-if="current">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-12 col-sm-1">
              <v-text-field
                label="Nome"
                v-model="current.name"
                outlined
                dense
              ></v-text-field>
            </div>
            <div class="col-md-12 col-sm-1">
              <v-text-field
                label="Responsável"
                v-model="current.responsable"
                outlined
                dense
              ></v-text-field>
            </div>
          </div>

          <v-tabs v-model="tab" grow class="mt-2">
            <v-tab key="dy"> Cadastro </v-tab>
            <v-tab key="ot"> Endereço </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item key="dy">
              <v-card flat>
                <v-card-text>
                  <div class="row">
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="CPF/CNPJ"
                        v-model="current.register"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="RG/IE"
                        v-model="current.register2"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="CFOP"
                        v-model="current.cfop"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-menu
                        v-model="menu_birth"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="computedBirth"
                            label="Nasc./Fund."
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            dense
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="current.birth"
                          @input="birthAlterada()"
                          locale="pt-br"
                        ></v-date-picker>
                      </v-menu>
                    </div>
                    <div class="col-md-4 col-sm-1">
                      <v-text-field
                        label="Telefone"
                        v-model="current.telephone"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-4 col-sm-1">
                      <v-text-field
                        label="Celular"
                        v-model="current.cellphone"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-4 col-sm-1">
                      <v-text-field
                        label="Fax"
                        v-model="current.fax"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-6 col-sm-1">
                      <v-text-field
                        label="Email"
                        v-model="current.email"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-6 col-sm-1">
                      <v-text-field
                        label="Site"
                        v-model="current.site"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-6 col-sm-1">
                      <v-textarea
                        label="Emails adicionais"
                        v-model="current.emailExtra"
                        outlined
                        dense
                      ></v-textarea>
                    </div>
                    <div class="col-md-6 col-sm-1">
                      <v-textarea
                        label="Observações"
                        v-model="current.obs"
                        outlined
                        dense
                      ></v-textarea>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="ot">
              <v-card flat>
                <v-card-text>
                  <div class="row">
                    <div class="col-md-6 col-sm-1">
                      <v-text-field
                        label="Logradouro"
                        v-model="current.address"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Número"
                        v-model="current.addressNumber"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Complemento"
                        v-model="current.addressExtra"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Bairro"
                        v-model="current.addressNeiborhood"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="Cidade"
                        v-model="current.city"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="Estado"
                        v-model="current.province"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="País"
                        v-model="current.country"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="CEP"
                        v-model="current.zipcode"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn color="success" @click="save()">Salvar</v-btn>
        </div>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null,
    tab: null,
    menu_birth: false,
    dialog_loading: false,
  }),
  created: function () {
    this.load();
  },
  methods: {
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/client/0", {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao gerar formulario de cadastro!");
          console.log(error);
        });
    },
    save: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .post("/client", this.current, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function () {
          me.dialog_loading = false;
          alert("Cliente cadastrado com sucesso!");
          router.push({ path: "/client" });
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao salvar formulario de cadastro!");
          console.log(error);
        });
    },
    formatDate: function (date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    birthAlterada: function () {
      this.menu_birth = false;
    },
  },
  computed: {
    computedBirth() {
      return this.formatDate(this.current.birth);
    },
  },
};
</script>
